import React, { useState, useEffect, useRef, useMemo } from 'react'
import { Dialog } from '../components/ui/dialog'
import { BreadcrumbProps } from '@blueprintjs/core'
import { Callout } from '../components/ui/callout'
import { Card } from '../components/ui/card'
import { axiosDestroy, axiosGet, axiosPost } from '../util/api'
import { Layout } from '../components/Layout'
import copy from 'copy-to-clipboard'
import { Toasts } from '../components/toaster/Toast'
import { Button } from '../components/ui/button'

export interface Token {
    id: number
    tokenable_type: string
    tokenable_id: number
    name: string
    abilities: string[]
    last_used_at?: any
    created_at: Date
    updated_at: Date
}

export const Integrations = ({}) => {
    const [tokens, setTokens] = useState<Token[]>([])
    const [creatingExtensionToken, setCreatingExtensionToken] = useState<boolean>(false)
    const [token, setToken] = useState<string>('')
    const [deleting, setDeleting] = useState<{ [key: number]: boolean }>([])

    const ref = useRef()

    const load = () => {
        axiosGet('tokens')
            .then((res) => {
                console.log('res is', res)
                setTokens(res.data)
            })
            .catch((err) => {
                console.error('tokens error', err)
            })
    }

    useEffect(() => {
        load()
    }, [])

    const createExtensionToken = () => {
        setCreatingExtensionToken(true)
        axiosPost('tokens/extension')
            .then((res) => {
                console.log('res is', res)
                setToken(res.data.token)
                setCreatingExtensionToken(false)
                load()
            })
            .catch((err) => {
                console.error('createExtensionToken error', err)
                setCreatingExtensionToken(false)
            })
    }

    const deleteToken = (token: Token) => {
        setDeleting((p) => ({
            ...p,
            [token.id]: true,
        }))
        axiosDestroy(`tokens/${token.id}`)
            .then((res) => {
                console.log('res is', res)
                load()
                Toasts.success('Token deleted')
                setDeleting((p) => ({
                    ...p,
                    [token.id]: false,
                }))
            })
            .catch((err) => {
                console.error('createExtensionToken error', err)
                setDeleting((p) => ({
                    ...p,
                    [token.id]: false,
                }))
            })
    }

    const extensionToken: Token | undefined = useMemo(() => {
        return tokens.find((t) => t.name === 'extension')
    }, [tokens])

    const breadcrumbs: BreadcrumbProps[] = [{ text: 'Account Settings' }]

    console.log('Tokens is', tokens, extensionToken)
    return (
        <Layout breadcrumbs={breadcrumbs} primary="Integrations">
            <div className="mb-4">
                <Card className="p-4 bp4-card-rounded">
                    <h4>Extension</h4>
                    {!extensionToken && (
                        <div className="flex flex-col">
                            <div className="mb-2">
                                Not yet setup. Click the button below to create your integration
                                token.
                            </div>
                            <div>
                                <Button
                                    loading={creatingExtensionToken}
                                    intent="primary"
                                    text="Setup Integration"
                                    onClick={createExtensionToken}
                                />
                            </div>
                        </div>
                    )}
                    {extensionToken && (
                        <div className="flex flex-col">
                            <Callout intent="success" title="Your extension token is setup" />
                            <div className="mt-4 mb-2">Your token is setup!</div>
                            <div>
                                <Button
                                    text="Delete Token"
                                    loading={!!deleting[extensionToken.id]}
                                    onClick={() => deleteToken(extensionToken)}
                                />
                            </div>
                        </div>
                    )}
                </Card>
            </div>
            <Dialog isOpen={!!token} onClose={() => setToken('')} className="p-4">
                <div className="mb-2">
                    Your token is below. Click the copy icon to copy to clipboard.
                </div>
                <div className="mb-4">
                    This token will only be shown once! Make sure you copy it into the extension.
                </div>
                <div className="flex items-center">
                    <Button
                        icon="duplicate"
                        title="Copy to clipboard"
                        onClick={() => {
                            copy(token)
                            Toasts.success('Token copied to clipboard')
                        }}
                    />
                    <code
                        className="bg-white h-7 border px-2"
                        onFocus={(e) => {
                            // @ts-ignore
                            e.target.select()
                            // @ts-ignore
                            e.target.setSelectionRange(0, token.length)
                        }}
                    >
                        {token}
                    </code>
                </div>
            </Dialog>
        </Layout>
    )
}
